module.exports = __webpack_public_path__ + "media/images/lb/793-c05cb60c8c2b7a9be6761485d5167e70.svg";